import { useEffect, useState, forwardRef, useImperativeHandle, useRef } from 'react'
import { Modal, message, InputNumber, Input, Empty } from 'antd'
import { apiObj } from '@/common/common'
import playing from '../../assets/img/playing.gif'

const wrapClass = {
  display: 'flex',
  justifyContent: 'flex-start',
  alignItems: 'center',
  marginTop: '20px'
}
const color = {
  color: 'var(--color)'
}
const labelClass = {
  width: '85px',
  textAlignLast: 'justify',
  flexShrink: 0
}
const inpClass = {
  width: '100%'
}

const List = forwardRef((props, ref) => {
  const [currentPlay, setCurrentPlay] = useState('') // 正在播放的歌曲
  const [songList, setSongList] = useState([])
  const [searchFlag, setSearchFlag] = useState(false) // 搜索歌曲标志
  const [songValue, setSongValue] = useState('') // 搜索歌曲
  const [flag, setFlag] = useState(false) // 排序弹窗
  const [sortObj, setSortObj] = useState({}) // 排序对象
  const [confirmLoading, setConfirmLoading] = useState(false) // 确认按钮loading
  const [sortValue, setSortValue] = useState('') // 排序值

  const _songList = useRef(songList) // 初始的歌曲列表
  const timer = useRef(null) // 防抖定时器
  const inputRef = useRef(null)

  // 搜索框显示的时候聚焦
  useEffect(() => {
    if (searchFlag) {
      inputRef.current.focus()
    }
  }, [searchFlag])
  useEffect(() => {
    // console.log('歌曲搜索值', songValue)
    clearTimeout(timer.current)
    if (songValue) {
      timer.current = setTimeout(() => {
        let arr = _songList.current.filter(item => item.songName.includes(songValue))
        console.log('筛选的', arr)
        setSongList(arr)
      }, 500)
    } else {
      setSongList(_songList.current)
    }
  }, [songValue])
  // 获取歌曲列表
  const getSongList = val => {
    _songList.current = val
    setSongValue('')
    setSongList(val)
  }
  // 歌曲切换设置列表当前播放状态
  const setCurrentSong = val => {
    setCurrentPlay(val)
  }
  // 播放歌曲
  const playSong = val => {
    if (currentPlay.songName === val.songName) return
    setCurrentPlay(val)
    props.setPlaySong(val, 'list') // 只有点击列表上的播放的时候才会更改父组件的plytList，正常简单做歌单tab切换的时候不会更改
  }
  // 歌曲排序
  const setSort = val => {
    console.log(val)
    setSortObj(val)
    setFlag(true)
    setSortValue(val.sort)
  }
  // 确认
  const confirm = () => {
    console.log('确认')
    if (!sortValue) {
      message.warning('请输入排序值')
      return
    }
    const obj = {
      sheetId: sortObj.sheetId,
      newSort: sortValue,
      songId: sortObj.songId
    }
    console.log(obj)
    setConfirmLoading(true)
    fetch(`${apiObj.url}/song/sort`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json'
      },
      body: JSON.stringify(obj)
    })
      .then(res => res.json())
      .then(res => {
        console.log('结果', res)
        setConfirmLoading(false)
        if (res.code !== 200 || !res.data.flag) {
          message.error(res.data.msg)
          return
        }
        message.success('修改成功')
        setFlag(false)
        props.refreshList()
      })
  }
  // 导出父组件可调用的方法
  useImperativeHandle(ref, () => ({
    getSongList,
    setCurrentSong
  }))

  return (
    <>
      <div className="song_box ">
        <div className="song_head">
          <span className="txt0">序号</span>
          <span className="txt1" onClick={() => setSearchFlag(true)}>
            {!searchFlag ? (
              <span>{songValue ? `搜索：${songValue}` : '歌曲名（点击可搜索）'}</span>
            ) : (
              <>
                <Input
                  allowClear
                  className="inp"
                  ref={inputRef}
                  placeholder="请输入歌曲名"
                  value={songValue}
                  onChange={e => setSongValue(e.target.value)}
                  onBlur={() => setSearchFlag(false)}
                />
              </>
            )}
          </span>
          <span className="txt2">歌手</span>
          <span className="txt3">操作</span>
        </div>
        <ul className="song_wrap personScroll">
          {songList.length ? (
            songList.map((item, index) => {
              return (
                <li
                  key={item.songId + item.singer}
                  className={currentPlay.songName === item.songName ? 'active_song' : ''}
                >
                  <span className="txt0">
                    {currentPlay.songName !== item.songName ? (
                      <span>{index + 1}</span>
                    ) : (
                      <img src={playing} alt="" />
                    )}
                  </span>
                  <span
                    className="txt1 ov1"
                    onDoubleClick={() => playSong(item)}
                    title={item.songName}
                  >
                    {item.songName}
                  </span>
                  <span className="txt2 ov1" title={item.singer}>
                    {item.singer}
                  </span>
                  <span className="txt3">
                    <span onClick={() => playSong(item)}>播放</span>
                    <span onClick={() => setSort(item)}>排序</span>
                  </span>
                </li>
              )
            })
          ) : (
            <Empty
              className="no_data"
              imageStyle={{ width: '100%', height: 'auto' }}
              description="今天真是寂寞如雪啊~"
              image="https://image.kuaizilife.com/upload/index_icon/20250823/1755933314.png"
            />
          )}
        </ul>
      </div>
      {/* 排序弹框 */}
      <Modal
        title="歌曲排序"
        open={flag}
        onOk={confirm}
        confirmLoading={confirmLoading}
        onCancel={() => setFlag(false)}
      >
        <div style={wrapClass}>
          <span style={labelClass}>当前歌曲：</span>
          <span style={color}>{sortObj.songName}</span>
        </div>
        <div style={wrapClass}>
          <span style={labelClass}>排序：</span>
          <InputNumber
            style={inpClass}
            placeholder="请输入排序值，越小越靠前"
            min={1}
            value={sortValue}
            onChange={e => setSortValue(e)}
          />
        </div>
      </Modal>
    </>
  )
})

export default List
